(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoko-hub-grid"]) return;
  try {
    
if (document.querySelector('#ShokoAllProducts')) {
 customElements.whenDefined('facet-filters-form').then(() => {
  const facets = customElements.get('facet-filters-form');
  if (facets.shokoHubPatched) return;
  const original = facets.renderPage;
  facets.renderPage = function(searchParams, event, updateURLHash = true) {
   const params = new URLSearchParams(searchParams);
   params.set('view', 'chocolate-hub');
   const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
   if (preview) params.set('preview_theme_id', preview);
   return original.call(this, params.toString(), event, updateURLHash);
  };
  facets.shokoHubPatched = true;
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shokolati-shipping-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('shipping-city-directory')) {
 customElements.define('shipping-city-directory',class extends HTMLElement {
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.querySelector('.sh-hub__tools').hidden=false;
   const input=this.querySelector('input');const cities=Array.from(this.querySelectorAll('[data-city]'));const filters=Array.from(this.querySelectorAll('[data-filter]'));let region='all';
   const normalize=value=>value.replace(/[־–—"'״׳]/g,'').replace(/\s+/g,'').trim();
   const update=()=>{let count=0;const term=normalize(input.value);cities.forEach(city=>{const match=(region==='all'||city.dataset.region===region)&&normalize(city.dataset.city).includes(term);city.hidden=!match;if(match)count++;});this.querySelector('.sh-hub__count').textContent='מוצגות '+count+' ערים ויישובים';this.querySelector('.sh-hub__empty').hidden=count>0;};
   input.addEventListener('input',update);filters.forEach(button=>button.addEventListener('click',()=>{region=button.dataset.filter;filters.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));update();}));
   this.querySelector('[data-reset]').addEventListener('click',()=>{input.value='';region='all';filters.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter==='all')));update();input.focus();});
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
